import Hero from "../components/Hero";
import About from "../components/About";
import TechMarquee from "../components/TechMarquee";
import Services from "../components/Services";
import PortfolioCarousel from "../components/PortfolioCarousel";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);

  return (
    <main data-testid="home-page" className="grain">
      <Hero />
      <About />
      <TechMarquee />
      <Services />
      <PortfolioCarousel />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
